import React from "react";
import $ from "jquery";

export function correctHeight() {
    var pageWrapper = $("#page-wrapper");
    var navbarHeight = $("nav.navbar-default").height();
    var wrapperHeigh = pageWrapper.height();

    if (navbarHeight > wrapperHeigh) {
        pageWrapper.css("min-height", navbarHeight + "px");
    }

    if (navbarHeight <= wrapperHeigh) {
        if (navbarHeight < $(window).height()) {
            pageWrapper.css("min-height", $(window).height() + "px");
        } else {
            pageWrapper.css("min-height", navbarHeight + "px");
        }
    }

    if ($("body").hasClass("fixed-nav")) {
        if (navbarHeight > wrapperHeigh) {
            pageWrapper.css("min-height", navbarHeight + "px");
        } else {
            pageWrapper.css("min-height", $(window).height() - 60 + "px");
        }
    }
}

export function detectBody() {
    if ($(document).width() < 769) {
        $("body").addClass("body-small");
    } else {
        $("body").removeClass("body-small");
    }
}

export function smoothlyMenu() {
    if (!$("body").hasClass("mini-navbar") || $("body").hasClass("body-small")) {
        // Hide menu in order to smoothly turn on when maximize menu
        $("#side-menu").hide();
        // For smoothly turn on menu
        setTimeout(function() {
            $("#side-menu").fadeIn(400);
        }, 200);
    } else if ($("body").hasClass("fixed-sidebar")) {
        $("#side-menu").hide();
        setTimeout(function() {
            $("#side-menu").fadeIn(400);
        }, 100);
    } else {
        // Remove all inline style from jquery fadeIn function to reset menu state
        $("#side-menu").removeAttr("style");
    }
}

const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.*\d{0,3}Z{0,1}$/;
export function dateConvert(key, value) {
    if (typeof value === "string" && dateFormat.test(value)) {
        return new Date(value);
    }

    return value;
}

export function convertKodFarby(kodFarby) {
    kodFarby = ("000000" + kodFarby.toString(16)).slice(-6);
    kodFarby = kodFarby[4] + kodFarby[5] + kodFarby[2] + kodFarby[3] + kodFarby[0] + kodFarby[1];
    return kodFarby;
}

export function kodFarbyCell(props) {
    const style = {
        backgroundColor: props.dataItem.kodFarby ? `#${convertKodFarby(props.dataItem.kodFarby)}` : ""
    };
    return (
        <td className="color-cell">
            <div style={style}></div>
        </td>
    );
}



// WEBPACK FOOTER //
// ./src/components/common/Helpers.js